import { sum } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Total } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { useAgGridClientTableContext } from 'core/states';

const STATUS_PANEL_CLASS = 'ag-status-name-value ag-status-panel';

export const QuantityTotalsStatusBar = () => {
  const { t } = useTranslation();

  const { rows } = useAgGridClientTableContext();

  const totalQuantity = useMemo(() => {
    const total = sum(rows.map((row) => Number(row.quantity) || 0));

    if (!total) {
      return undefined;
    }

    return NumberHelper.format({ amount: total, decimals: 0 });
  }, [rows]);

  return (
    <Total
      label={t('labelQuantities')}
      value={totalQuantity}
      options={{ classNames: STATUS_PANEL_CLASS }}
    />
  );
};
